module.exports = __webpack_public_path__ + "static/media/33.9ebc7ae4.jpg";